import { getChromeAlarms } from './chrome/wrappers';
import { getCurrentDateTime, nowImmediate } from './lib/dateTime';

const MS_PER_MINUTE = 60 * 1000;

/**
 * Formats alarm timestamps in UTC so logs from different devices are comparable.
 */
export const formatAlarmTimestamp = (timestamp: number): string =>
  getCurrentDateTime(timestamp, 'utc').toISO() ?? `${timestamp}`;

export const createAlarmWithDelay = (name: string, delayInMinutes: number) => {
  const scheduledTime = nowImmediate() + delayInMinutes * MS_PER_MINUTE;
  console.log(
    `[Alarms] Scheduled "${name}" for ${formatAlarmTimestamp(
      scheduledTime
    )} (delayInMinutes=${delayInMinutes})`
  );

  getChromeAlarms().create(name, { delayInMinutes });
};

export const clearAlarm = (name: string): Promise<boolean> =>
  new Promise<boolean>(resolve => {
    getChromeAlarms().clear(name, wasCleared => resolve(!!wasCleared));
  });
